module.exports = __webpack_public_path__ + "images/a9e815ffa67d3f20c3e514686b49faf4.png";